import { useMemo } from 'react'
import { useCareReasons } from '@/hooks/useCareReasons'
import { useInfiniteCareReasons } from '@/hooks/useInfiniteCareReasons'
import { useAccessControlFilterFn } from '@/hooks/useAccessControlFilter'

export function useAccessControlledCareReasons() {
  const { data: reasons, isLoading } = useCareReasons()
  const { filterItems, isReady } = useAccessControlFilterFn('reasonId')

  const filteredReasons = useMemo(() => {
    if (!reasons || !isReady) return reasons
    return filterItems(reasons)
  }, [reasons, isReady, filterItems])

  return { data: filteredReasons, isLoading }
}

export function useAccessControlledInfiniteCareReasons() {
  const infiniteResult = useInfiniteCareReasons()
  const { filterItems, isReady } = useAccessControlFilterFn('reasonId')

  const filteredData = useMemo(() => {
    if (!infiniteResult.data?.pages || !isReady) return infiniteResult.data

    return {
      ...infiniteResult.data,
      pages: infiniteResult.data.pages.map((page) => ({
        ...page,
        careReasons: filterItems(page.careReasons),
      })),
    }
  }, [infiniteResult.data, isReady, filterItems])

  return { ...infiniteResult, data: filteredData }
}
